import { useState } from "react";
import { JsonRpcProvider } from "ethers";
import _ from "lodash";
import { Box, Container } from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import { useAssetUpdaterList } from "../../hooks/useAssetUpdaterList";
import { useAddAssetUpdater } from "../../hooks/useAddAssetUpdater";
import { useRemoveAssetUpdater } from "../../hooks/useRemoveAssetUpdater";
import Top from "../../components/top/Top";
import DialogAddWalletAddress from "../../components/dialogAddWalletAddress/DialogAddWalletAddress";
import DialogStatus from "../../components/dialogStatus/DialogStatus";
import Loading from "../../components/loading/Loading";
import Tables from "../../components/tables/Tables";
import "./updateHolderPage.css";
import { useNavigate } from "react-router-dom";

export const UpdateHolderPage = () => {
    const navigate = useNavigate();
    const { library } = useWeb3React();
    const genProvider = new JsonRpcProvider(process.env.REACT_APP_RPC_PROVIDER);
    const { onAddAssetUpdater, waitAddAssetUpdater } = useAddAssetUpdater();
    const { onRemoveAssetUpdater, waitRemoveAssetUpdater } = useRemoveAssetUpdater();
    const { assetUpdaterList } = useAssetUpdaterList(genProvider);
    const [open, setOpen] = useState(false);
    const [address, setAddress] = useState("");
    const [openStatus, setOpenStatus] = useState(false);
    const [isError, setIsError] = useState(false);
    const [message, setMessage] = useState("");
    const [txHash, setTxHash] = useState("");
    const [loadData, setLoadData] = useState(false);
    const [isLoad, setIsLoad] = useState(false);

    const handleOpen = () => {
        setAddress("");
        setOpen(true);
    };
    const handleClose = () => {
        setAddress("");
        setOpen(false);
    };

    const onChangeAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAddress(event.target.value);
    };

    const handleAddWalletAddress = () => {
        onAddAssetUpdater(library.getSigner(), address)
            .then((value) => {
                const err = _.get(value, "err");
                const tx = _.get(value, "tx");
                const hash = _.get(value, "tx.hash");

                if (tx) {
                    setAddress("");
                    setLoadData(true);
                    setTimeout(() => {
                        setLoadData(false);
                    }, 5000);
                    handleClose();
                    setIsError(false);
                    setTxHash(hash);
                    setMessage("Success!");
                    setOpenStatus(true);
                } else {
                    setIsError(true);
                    setTxHash("");
                    setMessage(err);
                    setOpenStatus(true);
                }
            }).catch((err) => {
                setIsError(false);
                setMessage(err);
                setOpen(false);
                setOpenStatus(true);
            })
    };

    const handleRemoveAssetUpdater = (address: string) => {
        onRemoveAssetUpdater(library.getSigner(), address)
            .then((value) => {
                const err = _.get(value, "err");
                const tx = _.get(value, "tx");
                const hash = _.get(value, "tx.hash");

                if (tx) {
                    setLoadData(true);
                    setTimeout(() => {
                        setLoadData(false);
                    }, 5000);
                    handleClose();
                    setIsError(false);
                    setTxHash(hash);
                    setMessage("Success!");
                    setOpenStatus(true);
                } else {
                    setIsError(true);
                    setTxHash("");
                    setMessage(err);
                    setOpenStatus(true);
                }
            }).catch((err) => {
                setIsError(false);
                setMessage(err);
                setOpen(false);
                setOpenStatus(true);
            })
    };

    return (
        <Box display="flex" flexDirection="column">
            <Top
                title="Update"
                subTitle="Controller"
                description="Update holder data by the controller, choose to add or delete"
            />
            <Container maxWidth="sm">
                <Tables
                    rows={assetUpdaterList}
                    handleClick={() => handleOpen()}
                    onDelete={(addr: string) => handleRemoveAssetUpdater(addr)}
                    loading={loadData}
                />
            </Container>

            <DialogAddWalletAddress
                open={open}
                value={address}
                onClose={handleClose}
                title="Add"
                subTitle="Wallet Address"
                description="Enter wallet address in the field below to update the controller"
                // address="0xdf456weih560387570endi3dpwk8y37gfeug095behrfiweh343B"
                confirm={() => handleAddWalletAddress()}
                onChange={(e: any) => onChangeAddress(e)}
            />
            <DialogStatus
                open={openStatus}
                onClose={() => {
                    setOpenStatus(false);
                    setIsLoad(true);
                    const timer = setTimeout(() => { navigate(0); }, 7000);
                    return () => clearTimeout(timer);
                }}
                // confirm={() => handleBurnTotalSupply()}
                msgErr={isError}
                title="Confirm"
                subTitle={isError ? "Add Wallet Address" : message}
                description={isError ? message : txHash} />
            {waitAddAssetUpdater &&
                <Loading loading={waitAddAssetUpdater} />
            }
            {waitRemoveAssetUpdater &&
                <Loading loading={waitRemoveAssetUpdater} />
            }
            {isLoad &&
                <Loading loading={isLoad} />
            }

        </Box>
    );
};

export default UpdateHolderPage;
